// Should exactly match the palette found in 'design_system/_color.scss'
export enum Colors {
  Black = '#222233',
  GrayDark = '#535366',
  GrayLight = '#dddde2',
  OffWhite = '#f8f8fb',
  White = '#ffffff',
  PrimaryBlue = '#0645b1',
  Gold = '#b08920',
  Green = '#05b01c',
  Red = '#b60000',
}
